export enum ToolProperty {
  Name = 0,
  MESCode = 1,
}